import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RecaptchaIntegrator } from '@app/services/recaptcha-integrator/recaptcha-integrator.service';
import { LoaderService } from '../loader/loader.service';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-captcha-challenge-popup',
  standalone: true,
  imports: [
    MatIconModule,
    MatTooltipModule
  ],
  templateUrl: './captcha-challenge-popup.component.html',
  styleUrl: './captcha-challenge-popup.component.scss'
})
export class CaptchaChallengePopupComponent implements AfterViewInit {

  private recaptchaIntegrator = inject(RecaptchaIntegrator);
  public data = inject(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<CaptchaChallengePopupComponent>);

  ngAfterViewInit(): void {
    const element = document.querySelector('#widget');
    if (element) {
      const baseOptions = {
        sitekey: this.data.sitekey,
        'error-callback': () => this.errored(),
        callback: (token: string) => this.resolved(token),
      };

      this.recaptchaIntegrator.setValues(this.data.sitekey, 'checkbox');
      this.recaptchaIntegrator.renderV2(element, baseOptions);
    }
  }

  private resolved(token: string): void {
    this.dialogRef.close(token);
  }

  private errored(): void {
    this.dialogRef.close();
  }
}
